import { checkPermission } from '@/router/guards.ts'

const FaqModule = () => import('./FaqModule.vue')
const FaqIndex = () => import('./views/FaqIndex.vue')

export const faqRoute = {
  path: '/faqs',
  name: 'faq',
  component: FaqModule,
  meta: {
    title: 'Faqs',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'faqs-index',
      component: FaqIndex,
      meta: {
        permission: 'faq.view',
      },
      beforeEnter: checkPermission('faq.view'),
    },
  ],
}
